export default [
  'raw',
  'uncooked',
  'cooked',
  'broiled',
  'roasted',
  'braised',
  'grilled',
  'toasted',
  'steamed',
  'skinless',
  'boneless',
  'bone-in'
];